const allPages = () =>       //对应页面下拉框
  [
    {
      id: 9,
      label: '首页',
    },
    // {
    //   id: 0,
    //   label: '落地页'
    // },
    {
      id: 1,
      label: '引导页'
    },
    {
      id: 2,
      label: '视频库',
      srcType: 10,
      contentType: 51
    },
    {
      id: 3,
      label: '图片库',
      srcType: 6,
      contentType: 61
    },
    // {
    //   id: 4,
    //   label: '图标库'
    // },
    {
      id: 5,
      label: '案例库',
      srcType: 8,
      contentType: 91
    },
    // {
    //   id: 6,
    //   label: '海报库'
    // },
    // {
    //   id: 7,
    //   label: '电子书'
    // },
    {
      id: 8,
      label: '商品',
      srcType: 11,
      contentType: 33
    }
  ]


const allPageColumns =            //{页面id: 表格信息}
  {
    0:
      [
        {
          slot: 'selection',
          width: 55,
          title: ' ',
          align: 'center',
        },
        {
          title: '页面名称',
          key: 'name',
          minWidth: 250
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 200
        },
        {
          title: '状态',
          slot: 'status',
          align: 'center',
          width: 160
        },
        {
          title: '页面链接',
          key: 'url',
          width: 300,
          align: 'center',
          tooltip: true
        },
        {
          title: '复制',
          slot: 'copy',
          width: 100,
          align: 'left'
        }],
    1:
      [
        {
          slot: 'selection',
          width: 55,
          title: ' ',
          align: 'center',
        },
        {
          title: '页面名称',
          key: 'name',
          minWidth: 250
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 200
        },
        {
          title: '状态',
          slot: 'status',
          align: 'center',
          width: 160
        },
        // {
        //   title: '页面链接',
        //   key: 'url',
        //   width: 300,
        //   align: 'center',
        //   tooltip: true
        // },
        // {
        //   title: '复制',
        //   slot: 'copy',
        //   width: 100,
        //   align: 'left'
        // }
      ],
    2:
      [
        {
          slot: 'selection',
          width: 55,
          title: ' ',
          align: 'center',
        },
        {
          title: '分类',
          key: 'categoryName',
          width: 200,
          align: 'center'
        },
        {
          title: '分组',
          key: 'groupName',
          width: 200,
          align: 'center'
        },
        {
          title: '视频标题',
          key: 'title',
          minWidth: 250,
          tooltip: true,
        },
        {
          title: '视频时长',
          key: 'videoLength',
          width: 200,
          align: 'center'
        },
        {
          title: '播放',
          slot: 'play',
          align: 'center',
          width: 80,
        },
        // {
        //   title: '视频链接',
        //   key: 'url',
        //   minWidth: 300,
        //   align: 'center',
        //   tooltip: true,
        // },
        // {
        //   title: '复制',
        //   slot: 'copy',
        //   width: 100,
        //   align: 'left'
        // }
      ],
    3:
      [
        {
          slot: 'selection',
          width: 55,
          title: ' ',
          align: 'center',
        },
        {
          title: '图片标题',
          key: 'title',
          width: 250,
          tooltip: true
        },
        {
          title: '分类',
          key: 'categoryName',
          width: 110,
          align: 'center'
        },
        {
          title: '分组',
          key: 'groupName',
          width: 110,
          align: 'center'
        },
        {
          title: '预览',
          slot: 'preview',
          align: 'center',
          width: 96,
        },
        {
          title: '图片链接',
          key: 'url',
          minWidth: 400,
          align: 'center',
          tooltip: true,
        },
        {
          title: '复制',
          slot: 'copy',
          width: 100,
          align: 'left'
        }],
    4:
      [],
    5:
      [
        {
          slot: 'selection',
          width: 55,
          title: ' ',
          align: 'center',
        },
        {
          title: '分类',
          key: 'categoryName',
          width: 200,
          align: 'center'
        },
        {
          title: '分组',
          key: 'groupName',
          width: 200,
          align: 'center'
        },
        {
          title: '内容',
          key: 'content',
          minWidth: 250,
          tooltip: true
        },
        // {
        //   title: '链接',
        //   key: 'url',
        //   minWidth: 400,
        //   align: 'center',
        //   tooltip: true,
        // },
        // {
        //   title: '复制',
        //   slot: 'copy',
        //   width: 100,
        //   align: 'left'
        // }
      ],
    6:
      [],
    7:
      [],
    8:
      [
        {
          slot: 'selection',
          width: 55,
          title: ' ',
          align: 'center',
        },
        {
          title: '商品分类',
          key: 'categoryName',
          width: 200,
          align: 'center',
          tooltip: true
        },
        {
          title: '商品分组',
          key: 'groupName',
          width: 200,
          align: 'center',
          tooltip: true
        },
        {
          title: '商品名称',
          key: 'name',
          minWidth: 250,
          tooltip: true
        },
        {
          title: '状态',
          slot: 'status',
          width: 120,
          align: 'center',
        },
        // {
        //   title: '商品链接',
        //   key: 'url',
        //   minWidth: 300,
        //   align: 'center',
        //   tooltip: true,
        // },
        // {
        //   title: '复制',
        //   slot: 'copy',
        //   width: 100,
        //   align: 'center'
        // }
      ],
    9:
      [
        {
          slot: 'selection',
          width: 55,
          title: ' ',
          align: 'center',
        },
        {
          title: '页面名称',
          key: 'name',
          minWidth: 250
        },
        {
          title: '更新时间',
          key: 'updateTime',
          minWidth: 200
        },
        {
          title: '状态',
          slot: 'status',
          align: 'center',
          width: 160
        },
        // {
        //   title: '页面链接',
        //   key: 'url',
        //   width: 300,
        //   align: 'center',
        //   tooltip: true
        // },
        // {
        //   title: '复制',
        //   slot: 'copy',
        //   width: 100,
        //   align: 'left'
        // }
      ],
  }


export const getColumns = (type) => {
  return allPageColumns[type]
}

/**
 * 下拉框只显示某些页面
 */
export const getPages = (pageIds) => {
  if (!pageIds)
    return allPages()
  let result = allPages().filter(item => {
    return pageIds.findIndex(id => id === item.id) > -1
  })
  return result
}
